import {useGetBillingInformationListQuery} from '@dms/api/core';
import {getBillingInformationOptions} from '@dms/shared';

import {Nullish} from 'shared/web';

export function useBillingInformation() {
  const {data} = useGetBillingInformationListQuery({includeDeactivated: true});

  const billingInformations = data?.billingInformationListItems;

  const getOptions = (selectedId: string | Nullish) =>
    getBillingInformationOptions({billingInformations, selectedId, labelKey: 'companyName'});

  const getNameById = (id: string) =>
    billingInformations?.find((billingInformation) => billingInformation.id === id)?.companyName;

  return {getOptions, getNameById};
}
